import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiSearch, FiPlus, FiAlertCircle } from 'react-icons/fi';
import { pantryItems } from '../data/mockData';

export const Pantry = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <header className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
        <div>
          <h1 className="text-2xl font-bold text-steel-900 tracking-tight">Inventory Tracker</h1>
          <p className="text-steel-500">Real-time pantry status.</p>
        </div>
        <button className="bg-tomato-500 hover:bg-tomato-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2 shadow-sm">
          <SafeIcon icon={FiPlus} /> Add Item
        </button>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 panel">
          <div className="panel-header">
            Current Stock
            <div className="relative">
              <SafeIcon icon={FiSearch} className="absolute left-2 top-1/2 -translate-y-1/2 text-steel-400 text-xs" />
              <input type="text" placeholder="Filter..." className="pl-7 pr-2 py-1 bg-white border border-steel-200 rounded text-xs focus:outline-none focus:border-tomato-500 w-32" />
            </div>
          </div>
          <div className="divide-y divide-steel-100">
            {pantryItems.map(item => (
              <div key={item.id} className="p-4 flex items-center justify-between hover:bg-steel-50/50 transition-colors">
                <div className="flex-1">
                  <h4 className="font-medium text-steel-900">{item.name}</h4>
                  <span className="text-xs text-steel-400 font-mono">{item.category}</span>
                </div>
                
                <div className="flex-1 max-w-[200px] px-4">
                  <div className="flex justify-between text-xs font-mono mb-1">
                    <span className="text-steel-500">LEVEL</span>
                    <span className={item.stock < 20 ? 'text-tomato-500 font-bold' : 'text-steel-700'}>
                      {item.stock}{item.unit}
                    </span>
                  </div>
                  <div className="h-1.5 w-full bg-steel-100 rounded-full overflow-hidden">
                    <div 
                      className={`h-full rounded-full ${item.stock < 20 ? 'bg-tomato-500' : 'bg-steel-400'}`}
                      style={{ width: item.unit === '%' ? `${item.stock}%` : `${Math.min(item.stock * 10, 100)}%` }}
                    />
                  </div>
                </div>
                
                <div className="ml-4 w-8 flex justify-end">
                  {item.stock < 20 && <SafeIcon icon={FiAlertCircle} className="text-tomato-500" />}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="panel flex flex-col h-fit">
          <div className="panel-header bg-tomato-50 text-tomato-800 border-tomato-100">
            Auto-Shopping List
          </div>
          <div className="p-4 flex-1">
            <p className="text-sm text-steel-600 mb-4">Items detected below optimal threshold:</p>
            <ul className="space-y-3">
              {pantryItems.filter(i => i.stock < 20).map(item => (
                <li key={item.id} className="flex items-center gap-3 text-sm">
                  <input type="checkbox" className="rounded text-tomato-500 focus:ring-tomato-500 border-steel-300 w-4 h-4 cursor-pointer" />
                  <span className="text-steel-800">{item.name}</span>
                </li>
              ))}
              <li className="flex items-center gap-3 text-sm">
                 <input type="checkbox" className="rounded text-tomato-500 focus:ring-tomato-500 border-steel-300 w-4 h-4 cursor-pointer" />
                 <span className="text-steel-800">Garlic (User added)</span>
              </li>
            </ul>
            <button className="w-full mt-6 bg-steel-900 hover:bg-steel-800 text-white py-2 rounded text-sm font-medium transition-colors">
              Export to Cart
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};